import { tw } from 'utils/classnames'

interface RibbonProps {
  text: string
  side?: 'left' | 'right'
  size?: 'small' | 'large'
  color?: string
  className?: string
}

export function Ribbon({ text, color, side = 'left', size = 'large', className }: RibbonProps) {
  return (
    <div
      style={{ '--ribbon-bg-color': color ?? '#541156' }}
      className={tw(
        'text-cf-white absolute top-0 z-10 bg-[--ribbon-bg-color] font-bold uppercase tracking-wider',
        side === 'left' ? 'left-0' : 'right-0',
        size === 'large' ? 'text-12 px-6 py-[7px]' : 'text-10 px-3 py-1',
        className,
      )}
    >
      {side === 'right' ? (
        <div className="absolute left-[-5px] top-0 h-full border-b-[15px] border-l-[5px] border-t-[15px] border-b-[--ribbon-bg-color] border-l-transparent border-t-[--ribbon-bg-color]" />
      ) : null}
      {text}
      {side === 'left' ? (
        <div className="absolute right-[-5px] top-0 h-full border-b-[15px] border-r-[5px] border-t-[15px] border-b-[--ribbon-bg-color] border-r-transparent border-t-[--ribbon-bg-color]" />
      ) : null}
    </div>
  )
}
